import ComingSoon from '@Components/General/Feedback/ComingSoon';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/contacts/task-types')({
    component: ComingSoon,
});
